(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-hot-reload')) {
    class ProductHotReload extends HTMLElement {
      constructor() {
        super();
        this.cache = new Map();
        this.activeRequests = new Map();
        this.loadingTimeout = null;
        this.supportsViewTransitions = 'startViewTransition' in document;
        
        this.addEventListener('change', (event) => this.onVariantChange(event));
        this.addEventListener('mouseover', (event) => this.onMouseOver(event));
      }

      connectedCallback() {
        // Initialize inventory data from data-attributes on initial load
        this.updateInventoryData();
      }

      showLoadingState() {
        this.loadingTimeout = setTimeout(() => {
          this.classList.add('product-hot-reload--loading');
        }, 200);
      }

      hideLoadingState() {
        if (this.loadingTimeout) {
          clearTimeout(this.loadingTimeout);
          this.loadingTimeout = null;
        }
        this.classList.remove('product-hot-reload--loading');
      }

    buildRequestUrl(input) {
      // console.log('[BUILD URL] Input:', input);
      
      // In commune, variant inputs are NOT inside the form element
      const productFormElement = this.querySelector('form');
      
      if (!productFormElement) {
        console.warn('[BUILD URL] No form found in product-hot-reload component');
      }
      
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      if (!newProductUrl || !optionValueId) {
        console.warn('[BUILD URL] Missing product URL or option value ID', { newProductUrl, optionValueId });
        return null;
      }

      // console.log('[BUILD URL] Product URL:', newProductUrl);
      // console.log('[BUILD URL] Option Value ID:', optionValueId);

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(this.querySelectorAll('input[type="radio"]:checked[data-option-value-id]'));
      // console.log('[BUILD URL] Checked radios:', checkedRadios);
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(this.querySelectorAll('select[data-variant-input]'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // console.log('[BUILD URL] All selected values before hover adjustment:', selectedOptionValues);

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const foundInput = this.querySelector(`input[data-option-value-id="${id}"]`);
          return foundInput && foundInput.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      const finalUrl = `${newProductUrl}?section_id=${sectionId}${params}`;
      // console.log('[BUILD URL] Final URL:', finalUrl);
      return finalUrl;
    }

      onMouseOver(event) {
        
        const label = event.target.closest('label');
        if (!label) {
          return;
        }
        

        // Find the input - it can be either inside the label or a sibling (using for/id)
        let input = label.querySelector('input[type="radio"][data-product-hot-reload-trigger]');
        
        if (!input && label.hasAttribute('for')) {
          const inputId = label.getAttribute('for');
          // Escape the ID for querySelector to handle special characters like +, spaces, etc.
          const escapedId = CSS.escape(inputId);
          input = this.querySelector(`#${escapedId}[data-product-hot-reload-trigger]`);
        }
        
        if (!input) {
          return;
        }
        
        if (input.checked) {
          return;
        }
        

        const requestUrl = this.buildRequestUrl(input);
        if (!requestUrl) {
          return;
        }
        
        if (this.cache.has(requestUrl)) {
          return;
        }
        
        if (this.activeRequests.has(requestUrl)) {
          return;
        }

        this.fetchContent(requestUrl);
      }

      fetchContent(requestUrl) {
        const fetchPromise = fetch(requestUrl)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.cache.set(requestUrl, html);
            this.activeRequests.delete(requestUrl);
            return html;
          })
          .catch(error => {
            this.activeRequests.delete(requestUrl);
            throw error;
          });

        this.activeRequests.set(requestUrl, fetchPromise);
        return fetchPromise;
      }

      async onVariantChange(event) {
        // console.log('[CHANGE] Event:', event);
        // console.log('[CHANGE] Target:', event.target);
        // console.log('[CHANGE] Target checked:', event.target.checked);
        // console.log('[CHANGE] Has trigger attr:', event.target.hasAttribute('data-product-hot-reload-trigger'));
        
        if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

        // Prevent default form behavior and stop propagation to avoid conflicts
        event.preventDefault();
        event.stopPropagation();
        
        // console.log('[CHANGE] Event prevented and stopped');

        const requestUrl = this.buildRequestUrl(event.target);
        if (!requestUrl) {
          // console.log('[CHANGE] No request URL, aborting');
          return;
        }

        // console.log('[CHANGE] Request URL:', requestUrl);
        const productUrl = this.dataset.productUrl;
        this.showLoadingState();

        try {
          let html;
          if (this.cache.has(requestUrl)) {
            // console.log('[CHANGE] Using cached response');
            html = this.cache.get(requestUrl);
          } else if (this.activeRequests.has(requestUrl)) {
            // console.log('[CHANGE] Waiting for active request');
            html = await this.activeRequests.get(requestUrl);
          } else {
            // console.log('[CHANGE] Fetching new content');
            html = await this.fetchContent(requestUrl);
          }

          // console.log('[CHANGE] Updating product with transition');
          await this.updateProductWithTransition(html, productUrl, event.target.id);
          // console.log('[CHANGE] Update complete');
        } catch (error) {
          console.error('[CHANGE] Error updating product content:', error);
        } finally {
          this.hideLoadingState();
        }
      }

      async updateProductWithTransition(html, productUrl, targetId) {

        
        let updatedHtml = html.getElementById(this.id);
        
        if (!updatedHtml) {
          updatedHtml = html.querySelector('product-hot-reload');
        }
        
        if (!updatedHtml) {
          console.error('[UPDATE] Could not find updated product-hot-reload element');
          return;
        }

        // Check if the updated HTML has a valid variant
        const updatedVariantJsonEl = updatedHtml.querySelector('[data-current-variant-json]');
        if (updatedVariantJsonEl) {
          try {
            const updatedVariantData = JSON.parse(updatedVariantJsonEl.textContent);

            // If variant is null (invalid combination), inject fallback price from current product
            if (!updatedVariantData || updatedVariantData === null) {
              console.warn('[UPDATE] ⚠️ Invalid variant combination - using product base price as fallback');

              // Get the current product's base price element
              const currentPriceEl = this.querySelector('[data-product-price]');
              if (currentPriceEl) {
                // Find the price element in the updated HTML and replace it with current price
                const updatedPriceEl = updatedHtml.querySelector('[data-product-price]');
                if (updatedPriceEl && currentPriceEl) {
                  updatedPriceEl.innerHTML = currentPriceEl.innerHTML;
                }
              }
            }
          } catch (e) {
            console.error('[UPDATE] Failed to parse updated variant JSON:', e);
          }
        }

        // Use surgical DOM updates to preserve the 3D model (moving iframe causes reload)
        await this.surgicalUpdate(updatedHtml);

        // Update inventory data from data-attributes
        this.updateInventoryData();

        // Reinitialize the image slider - it will start at the correct slide based on server-rendered .starting-slide class
        this.reinitializeImageSlider();

        // Reinitialize image zoom (Photoswipe) after DOM replacement
        this.reinitializeImageZoom();

        // Reinitialize collapsibles (tabs/accordions) after DOM replacement
        this.reinitializeCollapsibles();

        // Update the hidden master select to match the current variant
        this.updateMasterSelect();

        // Update browser history
        this.updateBrowserHistory(productUrl);

        // Focus the changed input - escape the ID for querySelector
        if (targetId) {
          try {
            const escapedId = CSS.escape(targetId);
            const targetElement = this.querySelector(`#${escapedId}`);
            if (targetElement) {
              targetElement.focus();
            }
          } catch (error) {
            console.warn('[UPDATE] Could not focus target element:', targetId, error);
          }
        }
        
        // console.log('[UPDATE] Update complete!');
      }

      async surgicalUpdate(updatedHtml) {
        // Update dataset attributes
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;

        // Define selectors for elements to update (outside product-blocks)
        // Note: variant-wrappers and product blocks are handled separately below
        const selectorsToUpdate = [
          // JSON data
          '[data-variant-json]',
          '[data-current-variant-json]',
          '[data-current-variantmeta-json]',
          '[data-variantmeta-json]',
          '[data-product-tags-json]',
        ];

        // Update JSON textareas (outside product-blocks)
        selectorsToUpdate.forEach(selector => {
          const currentElements = this.querySelectorAll(selector);
          const newElements = updatedHtml.querySelectorAll(selector);

          currentElements.forEach((currentEl, index) => {
            const newEl = newElements[index];
            if (newEl) {
              currentEl.innerHTML = newEl.innerHTML;
            }
          });
        });

        // Special handling for product images - update but preserve 3D slide
        const currentImages = this.querySelector('[data-product-images]');
        const newImages = updatedHtml.querySelector('[data-product-images]');
        if (currentImages && newImages) {
          // Get current 3D slide to preserve
          const current3DSlide = currentImages.querySelector('.product-main-slide--3d');

          // Update slides individually, preserving 3D slide
          const currentSlides = currentImages.querySelectorAll('.product-main-slide:not(.product-main-slide--3d)');
          const newSlides = newImages.querySelectorAll('.product-main-slide:not(.product-main-slide--3d)');

          currentSlides.forEach((slide, index) => {
            const newSlide = newSlides[index];
            if (newSlide) {
              slide.innerHTML = newSlide.innerHTML;
              Array.from(newSlide.attributes).forEach(attr => {
                slide.setAttribute(attr.name, attr.value);
              });
            }
          });

          // Update thumbnails (they don't contain 3D model)
          const currentThumbs = this.querySelector('.product__thumbs');
          const newThumbs = updatedHtml.querySelector('.product__thumbs');
          if (currentThumbs && newThumbs) {
            // Preserve 3D thumbnail if exists
            const current3DThumb = currentThumbs.querySelector('.product__thumb-item--3d');
            const thumbsToUpdate = currentThumbs.querySelectorAll('.product__thumb-item:not(.product__thumb-item--3d)');
            const newThumbsItems = newThumbs.querySelectorAll('.product__thumb-item:not(.product__thumb-item--3d)');

            thumbsToUpdate.forEach((thumb, index) => {
              const newThumb = newThumbsItems[index];
              if (newThumb) {
                thumb.innerHTML = newThumb.innerHTML;
                Array.from(newThumb.attributes).forEach(attr => {
                  thumb.setAttribute(attr.name, attr.value);
                });
              }
            });
          }
        }

        // Update product blocks container, preserving 3D model only if it exists
        const currentBlocks = this.querySelector('[data-product-blocks]');
        const newBlocks = updatedHtml.querySelector('[data-product-blocks]');
        if (currentBlocks && newBlocks) {
          // Find the 3D model element before any changes
          const model3D = currentBlocks.querySelector('custom-3d-model');
          const placeholder = currentBlocks.querySelector('#vectary_model_placeholder');

          // Only do surgical update if there's a 3D model to preserve
          // Otherwise, just replace the entire content (faster and safer)
          if (model3D && placeholder) {
            const currentChildren = Array.from(currentBlocks.children);
            const newChildren = Array.from(newBlocks.children);

            currentChildren.forEach((currentChild, index) => {
              const newChild = newChildren[index];
              if (!newChild) return;

              // Check if this block contains the placeholder
              const childPlaceholder = currentChild.querySelector('#vectary_model_placeholder');

              if (childPlaceholder) {
                // This block contains the placeholder - update children around it
                const blockChildren = Array.from(currentChild.children);
                const newBlockChildren = Array.from(newChild.children);

                // Remove all children except placeholder
                blockChildren.forEach(child => {
                  if (child.id !== 'vectary_model_placeholder') {
                    child.remove();
                  }
                });

                // Insert new children from new HTML, skipping new placeholder
                newBlockChildren.forEach(newChildEl => {
                  if (newChildEl.id !== 'vectary_model_placeholder') {
                    const clone = newChildEl.cloneNode(true);
                    // Insert before placeholder if it comes before, after if after
                    const placeholderIndexInNew = newBlockChildren.findIndex(c => c.id === 'vectary_model_placeholder');
                    const thisIndexInNew = newBlockChildren.indexOf(newChildEl);

                    if (thisIndexInNew < placeholderIndexInNew) {
                      currentChild.insertBefore(clone, childPlaceholder);
                    } else {
                      currentChild.appendChild(clone);
                    }
                  }
                });

                // Ensure 3D model is still in placeholder
                if (!childPlaceholder.contains(model3D)) {
                  childPlaceholder.appendChild(model3D);
                }
              } else {
                // No placeholder in this block, safe to replace entirely
                currentChild.innerHTML = newChild.innerHTML;
                Array.from(newChild.attributes).forEach(attr => {
                  currentChild.setAttribute(attr.name, attr.value);
                });
              }
            });
          } else {
            // No 3D model to preserve - do a simple full replacement
            currentBlocks.innerHTML = newBlocks.innerHTML;
          }
        }
      }

      reinitializeImageSlider() {
        
        // Find the slider container
        const sliderContainer = document.querySelector('[data-product-photos]');
        if (!sliderContainer) {
          return;
        }

        // Count slides
        const slides = sliderContainer.querySelectorAll('.product-main-slide');

        // If only one slide, just add is-selected class and return
        if (slides.length <= 1) {
          if (slides[0]) {
            slides[0].classList.add('is-selected');
          }
          return;
        }

        // Find which slide should be the starting slide (server-rendered with .starting-slide class)
        let startingIndex = 0;
        slides.forEach((slide, index) => {
          if (slide.classList.contains('starting-slide')) {
            startingIndex = index;
            // console.log('[SLIDER INIT] Found starting slide at index:', index);
          }
        });

        // Destroy existing Flickity instance if it exists
        const existingInstance = window.Flickity && window.Flickity.data(sliderContainer);
        if (existingInstance) {
          // console.log('[SLIDER INIT] Destroying existing instance');
          existingInstance.destroy();
        }

        // Initialize Flickity with the correct starting index
        const sliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true, // Prevents height collapse
          childNav: document.querySelector('.product__thumbs--scroller'),
          childNavScroller: document.querySelector('.product__thumbs'),
          childVertical: sliderContainer.dataset.thumbPosition === 'beside',
          contain: true,
          dragThreshold: 25,
          fade: false,
          friction: 0.8,
          initialIndex: startingIndex, // Start at the server-rendered starting slide
          pageDots: false,
          prevNextButtons: sliderContainer.dataset.arrows === 'true',
          rightToLeft: theme.config.rtl,
          setGallerySize: true,
          wrapAround: true
        };

        if (window.theme && window.theme.Slideshow) {
          try {
            // console.log('[SLIDER INIT] Creating Flickity at index:', startingIndex);
            new theme.Slideshow(sliderContainer, sliderArgs);
            // console.log('[SLIDER INIT] Flickity initialized successfully');
          } catch (error) {
            console.error('[SLIDER INIT] Error creating Flickity:', error);
          }
        } else {
          console.warn('[SLIDER INIT] theme.Slideshow not available');
        }
      }

      reinitializeImageZoom() {

        // Find the image container
        const imageContainer = document.querySelector('[data-product-images]');
        if (!imageContainer) {
          return;
        }

        // Check if zoom is enabled
        if (imageContainer.dataset.zoom === 'false') {
          return;
        }

        // Find the section ID
        const productSection = document.querySelector('[data-section-type="product"]');
        if (!productSection) {
          return;
        }

        const sectionId = productSection.dataset.sectionId;

        // Initialize Photoswipe if available
        if (window.theme && window.theme.Photoswipe) {
          try {
            new theme.Photoswipe(imageContainer, sectionId);
          } catch (error) {
          }
        } else {
        }
      }

      reinitializeCollapsibles() {
        
        // Reinitialize collapsibles within this component only
        if (window.theme && window.theme.collapsibles && typeof theme.collapsibles.init === 'function') {
          try {
            // Pass this component as scope to only reinitialize collapsibles within it
            theme.collapsibles.init(this);
          } catch (error) {
          }
        } else {
        }
      }

      updateMasterSelect() {
        // console.log('[MASTER SELECT] Updating master select...');
        
        const variantId = this.dataset.variantId;
        if (!variantId) {
          console.warn('[MASTER SELECT] No variant ID found');
          return;
        }

        // console.log('[MASTER SELECT] Variant ID:', variantId);

        // Find the master select element (the hidden select that controls cart submission)
        const masterSelect = this.querySelector('select[name="id"][data-product-select]');
        if (!masterSelect) {
          console.warn('[MASTER SELECT] Master select element not found');
          return;
        }

        // console.log('[MASTER SELECT] Current value:', masterSelect.value);
        // console.log('[MASTER SELECT] Setting to:', variantId);

        // Update the select value to match the current variant
        masterSelect.value = variantId;

        // Dispatch a change event so other scripts (like Shop Pay Installments) can react
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // console.log('[MASTER SELECT] Master select updated to variant:', variantId);
      }
      
      triggerVariantImageChange() {
        // console.log('[IMAGE CHANGE] Triggering variant image change...');
        
        // Get the current variant data from the updated DOM
        const variantJsonElement = this.querySelector('[data-current-variant-json]');
        if (!variantJsonElement) {
          // console.log('[IMAGE CHANGE] No current variant JSON found');
          return;
        }
        
        try {
          const variantText = variantJsonElement.textContent;
          // console.log('[IMAGE CHANGE] Variant JSON text:', variantText);
          
          if (!variantText || variantText.trim() === '') {
            // console.log('[IMAGE CHANGE] Variant JSON is empty');
            return;
          }
          
          const variant = JSON.parse(variantText);
          // console.log('[IMAGE CHANGE] Parsed variant:', variant);
          
          if (!variant) {
            // console.log('[IMAGE CHANGE] Variant is null');
            return;
          }
          
          // Check if variant has a featured image
          if (!variant.featured_media || !variant.featured_media.id) {
            // console.log('[IMAGE CHANGE] Variant has no featured media');
            return;
          }
          
          // console.log('[IMAGE CHANGE] Variant has featured media:', variant.featured_media.id);
          
          // Find the product section container (where theme.js event listeners are attached)
          const productSection = this.querySelector('[data-section-type="product"]');
          if (!productSection) {
            // console.log('[IMAGE CHANGE] No product section found');
            return;
          }
          
          // console.log('[IMAGE CHANGE] Product section found:', productSection);
          // console.log('[IMAGE CHANGE] Dispatching variantImageChange event on product section');
          
          // Dispatch the event that theme.js is listening for
          productSection.dispatchEvent(new CustomEvent('variantImageChange', {
            detail: {
              variant: variant
            },
            bubbles: true
          }));
          
          
          // Alternative: Try to directly switch the image via Flickity
          // This is a fallback in case event listeners were lost during DOM replacement
          const mainSlider = productSection.querySelector('.product-main-slide');
          
          if (mainSlider) {
            // Look for thumbnail in the entire product section, not just main slider
            const targetThumb = productSection.querySelector(`.product__thumb[data-id="${variant.featured_media.id}"]`);
            
            if (targetThumb) {
              // Get the data-index from the thumbnail
              const imageIndex = parseInt(targetThumb.getAttribute('data-index'), 10);
              
              // Check if Flickity instance exists
              const flickityInstance = window.Flickity && window.Flickity.data(mainSlider);
              
              if (flickityInstance && typeof imageIndex === 'number' && imageIndex >= 0) {
                flickityInstance.select(imageIndex);
              }
            } else {
              const allThumbs = productSection.querySelectorAll('.product__thumb[data-id]');
             
            }
          }
        } catch (error) {
        }
      }
      
      syncVariantAvailability() {
        // In commune, inputs are NOT inside form, so search in the entire component
        const radios = this.querySelectorAll('input[type="radio"][data-option-value-id]');
        const optionStateMap = new Map();
        
        // Build state map from server-rendered HTML
        Array.from(radios).forEach(radio => {
          const valueId = radio.getAttribute('data-option-value-id');
          if (valueId) {
            const isDisabled = radio.classList.contains('disabled') ||
                               (radio.parentElement && radio.parentElement.classList.contains('disabled'));
            optionStateMap.set(valueId, isDisabled);
          }
        });
        
        // Apply disabled states - ONLY use classes, never the disabled attribute (for hot reload clickability)
        radios.forEach(radio => {
          const valueId = radio.getAttribute('data-option-value-id');
          if (!valueId || !optionStateMap.has(valueId)) return;
          
          const shouldBeDisabled = optionStateMap.get(valueId);
          const parentDiv = radio.parentElement;
          
          // Update radio - CLASS ONLY, no disabled attribute
          radio.classList.toggle('disabled', shouldBeDisabled);
          
          // Update parent
          if (parentDiv && parentDiv.classList.contains('variant-input')) {
            parentDiv.classList.toggle('disabled', shouldBeDisabled);
          }
          
          // Update label
          let label = radio.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.toggle('disabled', shouldBeDisabled);
          } else if (radio.id) {
            label = this.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
            if (label) {
              label.classList.toggle('disabled', shouldBeDisabled);
            }
          }
          
          // Update color swatch
          if (parentDiv) {
            const swatch = parentDiv.querySelector('.color-swatch');
            if (swatch) {
              swatch.classList.toggle('disabled', shouldBeDisabled);
            }
          }
        });
      }
      
      updateInventoryData() {
        // Read inventory data from data-attributes and populate window.inventories
        // This replaces the inline <script> that was previously in product-inventory.liquid
        window.inventories = window.inventories || {};
        
        this.querySelectorAll('.js-product-inventory-data').forEach(el => {
          const productId = el.dataset.productId;
          if (!productId) return;
          
          window.inventories[productId] = {};
          
          el.querySelectorAll('.js-variant-inventory-data').forEach(variantEl => {
            const variantId = variantEl.dataset.id;
            if (!variantId) return;
            
            window.inventories[productId][variantId] = {
              quantity: variantEl.dataset.quantity,
              policy: variantEl.dataset.policy,
              incoming: variantEl.dataset.incoming,
              next_incoming_date: variantEl.dataset.date
            };
          });
        });
      }

      updateBrowserHistory(productUrl) {
        const variantId = this.dataset.variantId;
        const url = new URL(productUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        
        // Preserve existing params except variant
        for (const [key, value] of currentUrl.searchParams.entries()) {
          if (key !== 'variant') {
            url.searchParams.set(key, value);
          }
        }
        
        if (variantId) {
          url.searchParams.set('variant', variantId);
        }
        
        window.history.pushState({}, '', url.toString());
      }
    }

    customElements.define('product-hot-reload', ProductHotReload);
  }
  } catch(e) { console.error(e); }
})();

})();
